import { render, staticRenderFns } from "./SubscriptionPlanCard.vue?vue&type=template&id=341eb902&scoped=true&"
import script from "./SubscriptionPlanCard.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341eb902",
  null
  
)

export default component.exports